module.exports = __webpack_public_path__ + "img/banner_lcc.e32e64a9.png";